__turbopack_context__.v({
  "backLink": "draw-module-scss-module__FXzqSa__backLink",
  "saveBadge": "draw-module-scss-module__FXzqSa__saveBadge",
  "topLeftUI": "draw-module-scss-module__FXzqSa__topLeftUI",
  "wrapper": "draw-module-scss-module__FXzqSa__wrapper",
});
